import React from 'react';
import PropTypes from 'prop-types';

import { buildClassName, ClassNamePropType } from 'Internals/react-utils';

import './style.css';

const Page = function ({ children, className }) {
  const attrs = {};

  return (
    <article className={buildClassName('page', className)} {...attrs}>
      {children}
    </article>
  );
};

Page.propTypes = {
  children: PropTypes.node,
  className: ClassNamePropType,
};

export default Page;
